import { useState } from 'react';
import { format } from 'date-fns';
import * as R from 'ramda';

import CreateWorkModal from '@atom/components/common/createWorkModals/CreateWorkModal';
import { usePreferences } from '@atom/hooks/usePreferences';
import colors from '@atom/styles/colors';

import { CalendarGap } from './weekViewUtils';

const styles = {
  textContain: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  gapEvent: {
    margin: '0.5rem',
    color: colors.neutral.gray,
  },
};

interface Props {
  event: CalendarGap;
  last: boolean;
}

const GapEvent = ({ event, last }: Props) => {
  const preferences = usePreferences();
  const requireWorkType = R.pathOr(
    false,
    ['workOrders', 'requireWorkType'],
    preferences,
  );

  const [workModalOpen, setWorkModalOpen] = useState(false);

  const handleCreateWork = () => {
    setWorkModalOpen(true);
  };

  const startTime = format(new Date(event.plannedStartDate), 'hh:mm a');
  // Display end of current day time as 12:00 AM, even though rational human
  //  beings know it's technically the next day. Displaying it as 12am is
  //  easier for our kind to process visually
  const endTime = last
    ? '12:00 AM'
    : format(new Date(event.dueDate), 'hh:mm a');

  return (
    <div style={styles.gapEvent}>
      <div style={styles.textContain}>
        {startTime} - {endTime}
      </div>
      <div
        style={{ ...styles.textContain, cursor: 'pointer' }}
        onClick={handleCreateWork}
      >
        + Create Work
      </div>
      <CreateWorkModal
        fromCalendarGap={event}
        open={workModalOpen}
        onClose={() => setWorkModalOpen(false)}
        workTemplateRequired={requireWorkType}
        redirectOnCreate
      />
    </div>
  );
};

export default GapEvent;
